// OpenObserve — ingest via HTTP REST (endpoint OTLP ou natif OpenObserve)
// Variables requises : VITE_OPENOBSERVE_ENDPOINT, VITE_OPENOBSERVE_TOKEN,
//                     VITE_OPENOBSERVE_ORG, VITE_OPENOBSERVE_STREAM

export class OpenObserveAdapter {
  #endpoint = ''
  #headers  = {}
  #stream   = 'rectorium'

  init({ environment } = {}) {
    const base   = import.meta.env.VITE_OPENOBSERVE_ENDPOINT ?? ''
    const token  = import.meta.env.VITE_OPENOBSERVE_TOKEN    ?? ''
    const org    = import.meta.env.VITE_OPENOBSERVE_ORG      ?? 'default'
    this.#stream = import.meta.env.VITE_OPENOBSERVE_STREAM   ?? 'rectorium'

    if (!base || !token) return

    this.#endpoint = `${base}/api/${org}/${this.#stream}/_json`
    this.#headers  = {
      'Content-Type': 'application/json',
      Authorization: `Basic ${token}`,
    }
    this.#env = environment
  }

  #env = 'production'

  #send(payload) {
    if (!this.#endpoint) return
    // Fire-and-forget — ne jamais bloquer l'app sur l'observabilité
    fetch(this.#endpoint, {
      method: 'POST',
      headers: this.#headers,
      body: JSON.stringify([{ ...payload, _timestamp: Date.now(), env: this.#env }]),
    }).catch(() => {}) // erreur réseau silencieuse
  }

  captureException(error, context) {
    this.#send({
      level: 'error',
      type: 'exception',
      message: error?.message ?? String(error),
      stack: error?.stack ?? '',
      context,
    })
  }

  captureMessage(message, level = 'info', context) {
    this.#send({ level, type: 'message', message, context })
  }

  setUser(_user) {
    // OpenObserve est sans état côté client — enrichissement user via #send si besoin futur
  }

  addBreadcrumb({ category, message, level = 'info', data }) {
    this.#send({ level, type: 'breadcrumb', category, message, data })
  }
}
